import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Button } from 'transfix-ui/components/Button'
import { LogoTransfix } from 'transfix-ui/components/LogoTransfix'
import { Box, Typography } from 'transfix-ui/core'
import { FP_SUPPORT_EMAIL } from 'apps/fleet-planner/config/constants'
import { resetToken } from 'apps/fleet-planner/utils/api/token'

export const ResetInviteLink = () => {
  const history = useHistory()
  const { token } = useParams<{ token: string }>()

  const [sentEmail, setSentEmail] = React.useState<string | undefined>()
  const [buttonDisabled, setButtonDisabled] = React.useState<boolean>(false)

  const submitHandler = () => {
    setButtonDisabled(true)
    resetToken(token)
      .then(email => setSentEmail(email))
      .catch(() => history.replace('invalid'))
  }

  const ctaBody = (
    <Box>
      <Typography variant='h3'>Sorry, this invite link has expired.</Typography>
      <Box my={3}>
        Invitation links expire 48 hours after being sent. Click the button below to email a new one
        and finish registering your transfix account.
      </Box>
      <Button
        fullWidth
        type='button'
        data-test='reset-link-button'
        onClick={submitHandler}
        disabled={buttonDisabled}>
        Request a new link
      </Button>
    </Box>
  )

  const sentBody = (
    <Box>
      <Typography variant='h3'>New invitation email sent!</Typography>
      <Box my={3}>
        We sent a new link to {sentEmail}. Follow the email instructions to continue creating your
        account.
      </Box>
      <Box my={3}>
        If the email address listed above is incorrect or you are still having problems please{' '}
        <a
          style={{ display: 'inline' }}
          href={`mailto:${FP_SUPPORT_EMAIL}?subject=Problems logging into FMS using my invite link (expired token)`}>
          contact our support team
        </a>
        , they will be happy to help.
      </Box>
    </Box>
  )

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      alignSelf='center'
      maxWidth='500px'
      textAlign='center'
      p={2}>
      <Box mt={6} mb={3}>
        <LogoTransfix color='black' />
      </Box>
      {sentEmail ? sentBody : ctaBody}
    </Box>
  )
}
